import {labelConfigSelector} from '../../../data/labelInfos/index.js'
import {FEDEX} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {useSelector} from '../../../store.js'
import ConfigButton from './ConfigButton.js'
import {showHoldAtLocationModal} from '../Modals/HoldAtLocationModal.js'
import {formatNumber} from '../../../common/components/PrettyNumber.js'
import {ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [FEDEX]

export function formatHoldAtLocationIDProperty(shipperType) {
  return `${shipperType}__hold_at_location_id`
}

function labelPropertiesFunc(shipperType) {
  return [formatHoldAtLocationIDProperty(shipperType)]
}

const VALID_LABEL_PROPERTIES = VALID_SHIPPER_TYPES.map((shipperType) =>
  formatHoldAtLocationIDProperty(shipperType),
)

export function holdAtLocationOptionsPropertyFunc(shipperType) {
  return `${shipperType}__hold_at_location_options`
}

export function holdAtLocationDisplay(location) {
  if (!location) {
    return ''
  }

  return `${location.address.company} (${formatNumber(
    location.distance.value,
    1,
  )} ${location.distance.units})`
}

export default function HoldAtLocation() {
  const {labelInfoID, shipperType} = useLabelConfigContext()
  const propertySpecs = HoldAtLocation.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const labelConfig = useSelector((state) =>
    labelConfigSelector(state, {labelInfoID}),
  )
  const locationID = labelConfig[labelProperty]
  const options =
    labelConfig[holdAtLocationOptionsPropertyFunc(shipperType)] || []
  const selectedOption = options.find(({id}) => locationID === id)

  return (
    <ConfigButton
      label="Hold at Location"
      onClick={showHoldAtLocationModal}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    >
      {selectedOption ? holdAtLocationDisplay(selectedOption) : 'Edit'}
    </ConfigButton>
  )
}

HoldAtLocation.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc() {
      return VALID_LABEL_PROPERTIES
    },
  },
]
